/**
 * Shopify CDN image transformation helper.
 *
 * Two quality modes:
 *   - default WebP (small, bandwidth-friendly) → used for product cards, thumbnails, cart lines
 *   - hq progressive JPEG → used for PDP hero image where the customer inspects fabric details.
 *
 * If the URL is not from Shopify (or is a placeholder / data URL), it's returned unchanged.
 */
export function optimizeImg(url, width, opts = {}) {
  if (!url || typeof url !== "string") return url;
  if (!url.includes("cdn.shopify.com")) return url;
  if (!width) return url;
  const sep = url.includes("?") ? "&" : "?";
  const format = opts.hq ? "pjpg" : "webp";
  return `${url}${sep}width=${width}&format=${format}`;
}

/**
 * Build a Shopify CDN srcset for responsive images.
 * Example: srcSet(url, [400, 800, 1200]) →
 *   "url?width=400&format=webp 400w, url?width=800&format=webp 800w, ..."
 */
export function srcSet(url, widths, opts = {}) {
  if (!url || !url.includes("cdn.shopify.com")) return undefined;
  return widths.map(w => `${optimizeImg(url, w, opts)} ${w}w`).join(", ");
}
